<h2>Select a time</h2>

<div class="flex justify-content-center">
  <div class="flex flex-column gap-3">
    @for (time of times; track $index) {
    <div class="field-checkbox">
      <p-radioButton [inputId]="time.formatedTime" name="time" [value]="time.formatedTime" [(ngModel)]="selectedFormatedTime" (onClick)="onTimeClick()" />
      <label [for]="time.formatedTime" class="ml-2">
        {{ time.formatedTime }}
      </label>
    </div>
    }
  </div>
</div>
<div class="flex justify-content-between mt-1 w-full">
  <p-button [routerLink]="['../', routes.SELECT_STATION]" label="BACK"></p-button>
  <p-button [routerLink]="['../', routes.OVERVIEW]" [disabled]="!selectedFormatedTime" label="NEXT"></p-button>
</div>
@if (isLoading()) {
<div class="progress-spinner">
  <p-progressSpinner></p-progressSpinner>
</div>
}